module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.c18403dd.woff2";